import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * The height / width ratio expressed as the result of dividing the content's height by its width.
  * e.g. 1) If your content is 16px wide and 9px tall, your ratio is 9 / 16 = 0.5625.
  * e.g. 2) If your content is a square, your ratio is 1.
  */
  ratio: PropTypes.number.isRequired
};
var AspectRatioContainer = createComponent({
  root: 'span',
  displayName: 'AspectRatioContainer',
  propTypes: propTypes,
  propConfig: {
    classNames: ['swan-aspect-ratio-container'],
    processProps: function processProps(props) {
      return _object_spread_props(_object_spread({}, props), {
        style: _object_spread_props(_object_spread({}, props.style || {}), {
          paddingBottom: props.ratio !== null ? "".concat(props.ratio * 100, "%") : undefined
        })
      });
    }
  }
});
export { AspectRatioContainer };